/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Billing frequency for the paid plan.
 * @export
 */
export const BillingCycle = {
    Monthly: 'monthly'
} as const;
export type BillingCycle = typeof BillingCycle[keyof typeof BillingCycle];


// @ts-ignore
export function BillingCycleFromJSON(json: any): BillingCycle {
    return BillingCycleFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingCycleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingCycle {
    return json as BillingCycle;
}

// @ts-ignore
export function BillingCycleToJSON(value?: BillingCycle | null): any {
    return value as any;
}

